export default "__VITE_ASSET__$HFZ6$NU__"